export default __webpack_public_path__ + "static/media/Bracers of Jagged Barbs.16346d1f.jpg";